<template>
  <div class="connected-numbers">
    <div class="row mb-3">
      <div class="col-12">
        <button class="btn btn-primary float-right" @click="openAddNumberModal">
          <i class="fa fa-plus"></i> Add Number
        </button>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>Link ID</th>
            <th>Phone Number</th>
            <th>Status</th>
            <th>Connected Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="numbers.length === 0">
            <td colspan="5" class="text-center">No Phone Numbers connected</td>
          </tr>
          <tr v-for="number in numbers" :key="number.linkId">
            <td>{{ number.linkId }}</td>
            <td>{{ number.mobileNumber }}</td>
            <td>
              <span :class="['badge', getStatusClass(number.status)]">
                {{ number.status }}
              </span>
            </td>
            <td>{{ formatDate(number.createdAt) }}</td>
            <td>
              <button v-if="number.status !== 'PENDING'" class="btn btn-outline-info btn-sm mr-2" @click="viewQRCode(number)">
                <i class="fa fa-qrcode"></i>
              </button>
              <button class="btn btn-outline-danger btn-sm" @click="unlinkNumber(number.linkId)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Add Number Modal -->
    <div class="modal fade" id="addNumberModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ modalTitle }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="!linkId && !viewingQR" class="qr-info">
              <p>We will generate a QR code for you to scan with your WhatsApp account. This process will take a few seconds.</p>
              <p>Please make sure you have WhatsApp installed on your phone and are ready to scan the QR code when it appears.</p>
            </div>
            <div v-else class="qr-container">
              <div v-if="qrCode" class="qr-code">
                <canvas ref="qrCodeCanvas"></canvas>
                <p class="qr-instructions">Scan this QR code with your WhatsApp to connect</p>
              </div>
              <div v-else class="loading">
                <p>Generating QR code...</p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button v-if="!linkId && !viewingQR" type="button" class="btn btn-success" @click="linkNumber">Continue</button>
            <button type="button" class="btn btn-light" @click="closeModal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import botApi from "@/shared/botApi";
import QRCode from "qrcode";

export default {
  name: 'ConnectedNumbers',
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      numbers: [],
      newNumber: {
        chatBotAppId: ""
      },
      linkId: "",
      qrCode: "",
      pollingInterval: null,
      pollingIntervalNumbers: null,
      linkStatusCheckCount:0,
      maxLinkStatusCheck:15,
      linkStatusCheckCount2:0,
      
      pendingNumbers: new Set(),
      viewingQR: false,
      modalTitle: "Connect WhatsApp Number"
    };
  },
  methods: {
    getNumbers() {
      const botId = this.$route.params.id;
      this.newNumber.chatBotAppId = botId;  
      if(this.pollingIntervalNumbers){
        clearInterval(this.pollingIntervalNumbers);
      }
      botApi
        .listLinkedWhatsAppNumbers(botId)
        .then((response) => {
          if (response.status === "00") {
            this.numbers = response.data;
            this.checkPendingNumbers();
          } else {
            this.toast.error(response.message || "Failed to fetch numbers");
          }
        })
        .catch((error) => {
          this.toast.error(error.message || "Failed to fetch numbers");
        });
    },
    checkPendingNumbers() {
      if (this.pollingIntervalNumbers) {
        clearInterval(this.pollingIntervalNumbers);
      }
      const pendingNumbers = this.numbers.filter(num => num.status === 'PENDING');
      if (pendingNumbers.length > 0) {
        // Start polling for pending numbers
        this.pollingIntervalNumbers = setInterval(() => {
            this.linkStatusCheckCount+=1;
            if(this.linkStatusCheckCount>=this.maxLinkStatusCheck){
                clearInterval(this.pollingIntervalNumbers);
                return;
            }
          pendingNumbers.forEach(number => {
            this.checkLinkStatus(number);
          });
        }, 10000);
      }
    },
   
    getStatusClass(status) {
      switch (status) {
        case 'CONNECTED':
          return 'badge-success';
        case 'PENDING':
          return 'badge-warning';
        case 'QR':
          return 'badge-primary';
        case 'FAILED':
          return 'badge-danger';
        case 'DISCONNECTED':
          return 'badge-danger';
        default:
          return 'badge-secondary';
      }
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
    },
    openAddNumberModal() {
      this.newNumber = {
        chatBotAppId: this.$route.params.id
      };
      this.linkId = "";
      this.qrCode = "";
      jQuery("#addNumberModal").modal("show");
    },
    closeModal() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
      this.linkId = "";
      this.qrCode = "";
      this.viewingQR = false;
      this.modalTitle = "Connect WhatsApp Number";
      setTimeout(() => {
        this.getNumbers();
      }, 12*1000);
      jQuery("#addNumberModal").modal("hide");
    },
    checkLinkStatus(number) {
      let linkId = number.linkId;    
      botApi
        .checkLinkStatus(linkId)
        .then((response) => {
          if (response.status === "00") {
            if(response.linkStatus === "QR"){
              this.viewQRCode({linkId: linkId, qrCode: response.qrCode});
            }else if(response.linkStatus === "CONNECTED"){
                this.getNumbers();
                this.toast.success("Number connected successfully");
                this.closeModal();
            }else if(response.linkStatus === "FAILED"){
                this.getNumbers();
                this.toast.success("Number failed to connect");
                this.closeModal();
            }
          } else {
            this.toast.error(response.message || "Failed to check link status");
          }
        })
        .catch((error) => {
          console.log(error.message || "Failed to check link status");
        });
    },
    linkNumber() {
      botApi
        .linkWhatsAppNumber(this.newNumber)
        .then((response) => {
          if (response.status === "00") {
            this.linkId = response.linkId;
            this.toast.success(response.message);
            // Start polling for QR code
            this.pollingInterval = setInterval(() => {
                this.linkStatusCheckCount2+=1;
                if(this.linkStatusCheckCount2>=this.maxLinkStatusCheck){
                    clearInterval(this.pollingInterval);
                    return;
                }

            this.checkLinkStatus({linkId: response.linkId}) 
            
            }
            , 10000);
          } else {
            this.toast.error(response.message);
          }
        })
        .catch((error) => {
          this.toast.error(error.message);
        });
    },
    unlinkNumber(linkId) {
      if (confirm("Are you sure you want to unlink this number?")) {
         botApi
          .unlinkWhatsAppNumber(linkId)
          .then((response) => {
            if (response.status === "00") {
              this.toast.success(response.message);
              this.getNumbers();
            } else {
              this.toast.error(response.message);
            }
          })
          .catch((error) => {
            this.toast.error(error.message);
          });
      }
    },
    viewQRCode(number) {
      this.viewingQR = true;
      this.modalTitle = "WhatsApp QR Code";
      this.linkId = number.linkId;
      this.qrCode = number.qrCode;
      jQuery("#addNumberModal").modal("show");
      // Generate QR code image
      this.$nextTick(() => {
        QRCode.toCanvas(this.$refs.qrCodeCanvas, this.qrCode, {
          width: 400,
          margin: 4,
        }).catch(err => {
          this.toast.error('Error generating QR code image');
        });
      });
    }
  },
  mounted() {
    this.getNumbers();
  },
  beforeDestroy() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
    if (this.pollingIntervalNumbers) {
      clearInterval(this.pollingIntervalNumbers);
    }
  }
};
</script>

<style scoped>
.connected-numbers {
  background-color: #2a3038;
  padding: 20px;
  border-radius: 4px;
}

.modal-body {
  padding: 0.4rem;
}

.qr-info {
  color: #e9e6e6;
  text-align: center;
}

.qr-info p {
  margin-bottom: 1rem;
}

.qr-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.2rem;
  min-height: 400px;
}

.qr-code {
  text-align: center;
  background-color: #fff;
  padding: 0.1rem;
  border-radius: 8px;
}

.qr-image {
  max-width: 250px;
  margin-bottom: 0.4rem;
}

.qr-instructions {
  color: #170863;
  margin-top: 0.5rem;
  font-size: 1.1rem;
}

.loading {
  color: #e9e6e6;
  text-align: center;
}

.table {
  background-color: #2a3038;
  color: #fff;
  margin-bottom: 0;
}

.table thead th {
  border-bottom: 1px solid #3c424a;
  color: #fff;
  font-weight: 500;
  padding: 12px;
}

.table tbody tr {
  border-bottom: 1px solid #3c424a;
}

.table tbody tr:hover {
  background-color: #3c424a;
}

.table tbody td {
  color: #fff;
  padding: 12px;
  vertical-align: middle;
}

.text-center {
  text-align: center;
  color: #6c757d;
  font-style: italic;
}

.btn-outline-danger {
  color: #ff4d6b;
  border-color: #ff4d6b;
}

.btn-outline-danger:hover {
  background-color: #ff4d6b;
  color: #fff;
}

.badge {
  padding: 0.5em 0.75em;
  font-size: 0.875em;
  font-weight: 500;
  border-radius: 0.25rem;
}

.badge-success {
  background-color: #28a745;
  color: #fff;
}

.badge-warning {
  background-color: #ffc107;
  color: #212529;
}

.badge-primary {
  background-color: #135475;
  color: #dce3eb;
}

.badge-danger {
  background-color: #dc3545;
  color: #fff;
}

.badge-secondary {
  background-color: #6c757d;
  color: #fff;
}

.btn-outline-info {
  color: #17a2b8;
  border-color: #17a2b8;
}

.btn-outline-info:hover {
  background-color: #17a2b8;
  color: #fff;
}

.mr-2 {
  margin-right: 0.5rem;
}
</style> 